import { useGetPropertyQuery } from "@/graphql/generated"
import { Col, Container, Row } from "react-grid-system"
import { useLocation, useNavigate } from "react-router"
import { NavTabsProps, NavTabsWithActions, PropertyTopBar } from "../molecules"
import { useEffect, useRef, useState } from "react"
import { LoadingSpinner } from "../atoms"
import { PropertyDetailTemplate } from "../templates"
import { useErrorHandlerContext, usePropertyDetailContext, useUserLanguage } from "@/customHooks"
import textsData from '@/textData/PropertyDetailTexts.json'
import { pathURL } from "@/components/constants/urls"

export const EstatePropertyDetailPage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.tabs : textsData.en.tabs

  const { property, setProperty } = usePropertyDetailContext()
  const [selectedTab, setSelectedTab] = useState('1')

  const isInitialMount = useRef(true);

  const { open: errorHandle } = useErrorHandlerContext()

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!location.state?.id) {
      navigate(`/${pathURL.USER}`, { replace: true })
    }
  }, [location.state?.id, navigate])

  const {data, error, loading, refetch} = useGetPropertyQuery({ 
    variables: {
      id: location.state?.id || ''
    },
    skip: !location.state?.id
  })

  const tabs: NavTabsProps[] = [
    { id: '1', label: texts.tab1 },
    { id: '2', label: texts.tab2 },
    { id: '3', label: texts.tab3 },
    { id: '4', label: texts.tab4 },
    { id: '5', label: texts.tab5 },
    { id: '6', label: texts.tab6 },
    { id: '7', label: texts.tab7 },
    { id: '8', label: texts.tab8 },
    { id: '9', label: texts.tab9 },
    { id: '10',label: texts.tab10 },
  ]

  useEffect(() => {
    if (data?.property) {
      setProperty(data.property);
    }
  }, [data, setProperty]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (property === undefined && !loading) {
      refetch();
    }
  }, [property, loading, refetch]);

  if (error) errorHandle(error)
  
  if (loading) {
    return (
      <Row justify="center">
        <Col xs="content">
          <LoadingSpinner />
          <p>Loading...</p>
        </Col>
      </Row>
    )
  }
  
  return (
    <>
      <PropertyTopBar
        name={data?.property?.name ?? 'No name available'}
        address={{
          street: data?.property?.address.street ?? '',
          buildingNumber: data?.property?.address.buildingNumber ?? '',
          addressLine: data?.property?.address.addressLine ?? '',
          city: data?.property?.address.city?.name ?? '',
          state: data?.property?.address.state?.name ?? '',
          country: data?.property?.address.country?.name ?? '',
          zipCode: data?.property?.address.zipCode ?? '',
        }}
      />
      <Row>
        <Col>
          <NavTabsWithActions
            tabs={tabs}
            onClick={setSelectedTab}
            selectedTabId={selectedTab}
          />
        </Col>
      </Row>
      <Container>
        <PropertyDetailTemplate selectedSection={selectedTab} />
      </Container>
    </>
  )
}